define('views/components/cd_personal/cd_personal_list',['require','views/base/list_view','views/components/cd_personal/cd_personal','text!templates/components/cd_personal/cd_personal_list.html'],function(require){

    var BaseListView = require('views/base/list_view');
    var ChildView = require('views/components/cd_personal/cd_personal');

    var temp = require("text!templates/components/cd_personal/cd_personal_list.html");
    return BaseListView.extend({
        template: _.template(temp),
        childView: ChildView
    });
});

